import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { RaceProgram } from "@tvg/ts-types/Race";
import { Tabs, Modal, TabList, Tab, TabPanel } from "@tvg/design-system";
import { TabSelectionPoolsNInfoEnum } from "../../../types";
import { WAGER_TYPE_LIMIT } from "../../Main/PoolsCard/constants";
import Probables from "../../Main/Probables";
import PoolsCard from "../../Main/PoolsCard";
import WillPays from "../../Main/WillPays";
import { ContentWrapper } from "./styled-components";
import { tabListHeader } from "./tabsListContent";
import InfoNChangesPro from "../../Main/InfoNChangesPro";
import { poolsNInfoTabOpenEvent } from "../../../utils/gtm/poolsAndInfo";

export const WAGER_ID_FILTER = 30;

interface Props {
  isOpen: boolean;
  onClose?: NullaryFn<void>;
  subTitle?: string;
  race: RaceProgram;
  races: RaceProgram[];
}

const PoolsNInfoModal = ({ isOpen, onClose, subTitle, race, races }: Props) => {
  const [selectedTab, setSelectedTab] = useState(
    TabSelectionPoolsNInfoEnum.INFO_CHANGES
  );
  const nextRaceIndex =
    races.findIndex((current) => current.tvgRaceId === race.tvgRaceId) + 1;
  const nextRace = get(races, nextRaceIndex);

  useEffect(() => {
    if (TabSelectionPoolsNInfoEnum.INFO_CHANGES !== selectedTab && isOpen) {
      setSelectedTab(TabSelectionPoolsNInfoEnum.INFO_CHANGES);
    }
  }, [isOpen]);

  const renderTabs = () => (
    <TabList qaLabel="tabList">
      {Object.entries(tabListHeader).map(([value, title]) => (
        <Tab key={title} value={value} title={title} noBorder />
      ))}
    </TabList>
  );

  const renderPoolsNInfoModal = () => (
    <Tabs
      selectedValue={selectedTab}
      onChange={(val) => {
        setSelectedTab(val as TabSelectionPoolsNInfoEnum);
        poolsNInfoTabOpenEvent({
          label: tabListHeader[val as TabSelectionPoolsNInfoEnum],
          trackName: race.track?.trackName,
          raceNumber: race.raceNumber
        });
      }}
      qaLabel="tab"
      isFullHeight
      useViewComponent
    >
      {renderTabs()}
      <TabPanel value={TabSelectionPoolsNInfoEnum.INFO_CHANGES} isFullHeight>
        <ContentWrapper shouldAlignContent={checkModalContent()}>
          <InfoNChangesPro
            changes={race.changes}
            currentRace={race}
            races={races}
          />
        </ContentWrapper>
      </TabPanel>
      <TabPanel value={TabSelectionPoolsNInfoEnum.PROBABLES} isFullHeight>
        <Probables currentRace={race} nextRace={nextRace} />
      </TabPanel>
      <TabPanel value={TabSelectionPoolsNInfoEnum.POOLS} isFullHeight>
        <PoolsCard
          wagerTypeLimit={WAGER_TYPE_LIMIT}
          racePools={race.racePools}
          bettingInterests={race.bettingInterests}
        />
      </TabPanel>
      <TabPanel value={TabSelectionPoolsNInfoEnum.WILL_PAYS} isFullHeight>
        <WillPays
          willPays={race.willPays}
          key={race.id || ""}
          bettingInterests={race.bettingInterests}
          raceNumber={race.raceNumber}
          trackName={race.track?.trackName}
        />
      </TabPanel>
    </Tabs>
  );

  const checkModalContent = (): boolean => {
    if (
      selectedTab === TabSelectionPoolsNInfoEnum.INFO_CHANGES &&
      !race.changes
    ) {
      return true;
    }
    if (
      selectedTab === TabSelectionPoolsNInfoEnum.PROBABLES &&
      !race.probables
    ) {
      return true;
    }
    if (selectedTab === TabSelectionPoolsNInfoEnum.POOLS && !race.racePools) {
      return true;
    }
    if (
      selectedTab === TabSelectionPoolsNInfoEnum.WILL_PAYS &&
      !race.willPays
    ) {
      return true;
    }

    return false;
  };

  return (
    <Modal
      title="Pools & Info"
      subtitle={subTitle}
      qaLabel="modal-PoolsNInfo"
      type="modal-custom-height"
      maxHeight="95%"
      isOpen={isOpen}
      onClose={onClose}
      padding={0}
    >
      {renderPoolsNInfoModal()}
    </Modal>
  );
};

export default PoolsNInfoModal;
